import { render, staticRenderFns } from "./PdfReview.vue?vue&type=template&id=0ae2654c&scoped=true"
import script from "./PdfReview.vue?vue&type=script&lang=js"
export * from "./PdfReview.vue?vue&type=script&lang=js"
import style0 from "./PdfReview.vue?vue&type=style&index=0&id=0ae2654c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae2654c",
  null
  
)

export default component.exports